var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 28.3334C18.6822 28.3334 22.0155 26.841 24.4284 24.4281C26.8413 22.0152 28.3337 18.6819 28.3337 15C28.3337 11.3182 26.8413 7.98482 24.4284 5.57193C22.0155 3.15907 18.6822 1.66669 15.0003 1.66669C11.3185 1.66669 7.98513 3.15907 5.57223 5.57193C3.15938 7.98482 1.66699 11.3182 1.66699 15C1.66699 18.6819 3.15938 22.0152 5.57223 24.4281C7.98513 26.841 11.3185 28.3334 15.0003 28.3334Z",
    fill: "#F2FFE6",
    stroke: "#2EB700",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 15L13.667 19L21.667 11",
    stroke: "#2EB700",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.f558cc8c90daef45c910932ac745dd79.svg";
export { ForwardRef as ReactComponent };